<div class="container">
  <div class="side-navi">
    <ul>
      <li><h4>Menu(appRouterPathActive)</h4></li>
      <li>
        <a
          #pathNone
          [routerLink]="['/routerlink']"
          appRouterPathActive="is-active"
        >
          none
        </a>
        <span>({{ pathNone.href }})</span>
      </li>
      <li>
        <a
          #pathHoge
          [routerLink]="['/routerlink', 'hoge']"
          appRouterPathActive="is-active"
        >
          hoge
        </a>
        <span>({{ pathHoge.href }})</span>
      </li>
      <li>
        <a
          #pathFuga
          [routerLink]="['/routerlink', 'fuga']"
          [queryParams]="{ piyo_id: piyoId }"
          appRouterPathActive="is-active"
        >
          fuga
        </a>
        <span>({{ pathFuga.href }})</span>
      </li>
      <br />
      <li><h4>Menu(routerLinkActive)</h4></li>
      <li>
        <a
          #linkNone
          [routerLink]="['/routerlink']"
          routerLinkActive="is-active"
        >
          none
        </a>
        <span>({{ linkNone.href }})</span>
      </li>
      <li>
        <a
          #linkHoge
          [routerLink]="['/routerlink', 'hoge']"
          routerLinkActive="is-active"
        >
          hoge
        </a>
        <span>({{ linkHoge.href }})</span>
      </li>
      <li>
        <a
          #linkFuga
          [routerLink]="['/routerlink', 'fuga']"
          [queryParams]="{ piyo_id: piyoId }"
          routerLinkActive="is-active"
        >
          fuga
        </a>
        <span>({{ linkFuga.href }})</span>
      </li>
    </ul>
  </div>
  <div class="content">
    <div>コンテンツ</div>
    <button class="btn-sm btn-info" (click)="incrementPiyoId()">
      PiyoIDをincrement
    </button>
    <div>{{ currentPath }}</div>
  </div>
</div>
